import { useTranslation } from "react-i18next";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import { useSelector } from "react-redux";
import { getOrderResultsTipDetails, getOrderStatusTipDetails } from "../../common/utils";

//const{t}=useTranslation();

// const { userLogin } = useSelector(authLoginSelector);

// "OrdernumHeader":"Order No.",
//     "fileorReferenceHeader":"Your File/Reference No.",
//     "LawyerNameHeader":"Lawyer Name",
//     "ClientNameHeader":"Client Name",
//     "PropertyAddressHeader":"Property Address",
//     "DealTypeHeader":"Deal Type",
//     "ClosingDateHeader":"Closing Date",
//     "StatusHeader":"Status",

export const columns = (userLogin, t, isCurrentFirmPromptFinancial) => {
  //const { t } = useTranslation();
  return [
    {
      Header: t("OrdernumHeader"),
      accessor: "fileNumber",
      width: 30,
      sortable: true,
      Cell: ({ row }) => {
        //spread the props
        //const redirectURL = `process/${row.original.filenumberEncrypted}`;
        const redirectURL =
          row.original.status &&
            row.original.status.toLowerCase() === "not yet submitted"
            ? `order/${row.original.fileNumber}`
            : `ordersummary/${row.original.fileNumber}`;
        return (
          <div className="ml-3">
            <a href={redirectURL} className="fileNumber text-secondary-blue">
              {row.original.fileNumber}
            </a>
          </div>
        );
      },
    },
    {
      Header: t("fileorReferenceHeader"),
      accessor: "internalReference",
      width: 50,
      sortable: true
    },
    ...(!userLogin?.isLawyer ? [{
      Header: t("LawyerNameHeader"),
      accessor: "lawyerName",
      width: 100,
      sortable: true

    }] : []),
    {
      Header: t("ClientNameHeader"),
      accessor: "clients",
      width: 140,
      expandLength: 16,
      expanded: false,
      Cell: ({ row }) => {
        //spread the props
        //const redirectURL = `process/${row.original.filenumberEncrypted}`;
        const clientsArray = row.original.clients.split(',');
        return (
          <div className="ml-3">
            {clientsArray.map((item) => {

              return (
                <div> {item}<br /></div>
              )
            })}

          </div>
        );
      },
    },
    {
      Header: t("PropertyAddressHeader"),
      accessor: "propertyAddress",
      width: 350,
      itemsToShow: 1,
      expandLength: 100,
      expanded: false,
      Cell: ({ row }) => {
        //spread the props
        //const redirectURL = `process/${row.original.filenumberEncrypted}`;
        const propArray = row.original.propertyAddress.split(';');
        return (
          <div className="ml-3">
            {propArray.map((item) => {

              return (
                <div> {item}<br /></div>
              )
            })}

          </div>
        );
      },
    },
    {
      Header: t("DealTypeHeader"),
      accessor: "dealType",
      width: 100,
      sortable: true
    },
    {
      Header: t("ClosingDateHeader"),
      accessor: "closingDate",
      width: 100,
      sortable: true,
      expanded: false,
      Cell: ({ row }) => {
        //spread the props
        //const redirectURL = `process/${row.original.filenumberEncrypted}`;
        const dateArray = row.original.closingDate?.split(',');
        return (
          <div className="ml-3">
            {dateArray?.map((item) => {

              return (
                <div> {item}<br /></div>
              )
            })}

          </div>
        );
      },
    },
    {
      Header: t("StatusHeader"),
      accessor: "status",
      width: 100,
      sortable: true,
      ToolTip: true,
      Cell: ({ row }) => {
        return getOrderStatusTipDetails(row.original.status, { t })
      },
    },
    ...(isCurrentFirmPromptFinancial ? [{
      Header: t("ResultsHeader"),
      accessor: "idvResult",
      width: 120,
      sortable: true,
      ToolTip: true,
      Cell: ({ row }) => {
        return getOrderResultsTipDetails(row.original?.idvResult, { t })
      },

    }] : []),

  ];
};

export const formatRowData = (rawData, lang) => {
  return rawData?.map((info) => ({
    fileNumber: info.fileNumber,
    fileID: info.fileID,
    filenumberEncrypted: info.encryptedURL,
    lawyerName: info.lawyerName,
    internalReference: info.internalReference,
    propertyAddress: info.propertyAddress,
    status: info.status,
    clients: info.clients,
    closingDate:
      info.closingDate === null || info.closingDate === ""
        ? "-"
        : info.closingDate,
    province: info.province,
    dealType: info.co === "IDV" ? (lang == "en" ? "ID Verification" : "Vérification d'identité") : info.co === "Co" ? (lang == "en" ? "Commercial" : "Commercial") : (lang == "en" ? "Residential" : "Résidentiel"),
    icon: info.icon,
    idvResult: info.idvResult,
  }));
};

export const groupbyArrayN = (arrays, N) => {
  const groupedArray = [];
  for (let i = 0; i < arrays.length; i += N) {
    groupedArray.push(arrays.slice(i, i + N));
  }
  return groupedArray;
};

export const getData = async (pageNo = 1) => {
  const response = await fetch(
    `https://api.instantwebtools.net/v1/passenger?page=${pageNo}&size=15`
  );
  const data = await response.json();
  return data;
  //   fetch(
  //     `https://api.instantwebtools.net/v1/passenger?page=${pageNo}&size=10`
  //   ).then((res) => res.json().then((data) => console.log(data)));
};
